import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import MessageBox from "../../../components/MessageBox/MessageBox";
import Preloader from "../../../components/Preloader/Preloader";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Chip from '@material-ui/core/Chip';
import { findIndex } from "lodash/array";
import LoadingOverlay from 'react-loading-overlay';
const useStyles = makeStyles((theme) => ({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

const PackageSalesPackagesItems = (props) => {
	const classes = useStyles();
	const navid = props.location.pageInfo ? props.location.pageInfo.navid : '';
    const CurrentPage = props.location.pageInfo ? props.location.pageInfo.navname : '';
    const TransactionInformation = props.location.transactionInfo ? props.location.transactionInfo : '';
    const PackageSalesInformation = props.location.selectedpackagesInfo ? props.location.selectedpackagesInfo : '';
    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF
    //ApiData Component useState SOF
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [nextPagePath, setnextPagePath] = useState("");
	const [isLoaded, setisLoaded] = useState(false);
    const [itemDetails, setitemDetails] = useState({});
    const [TABLE_DATA_ITEMS, loadItemTable] = useState([]);
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': process.env.REACT_APP_API_URL,
    };
    const get_packages_items = () => {
		//get data for warehouse/location dropdown
		const form_data = {
			packages_info: PackageSalesInformation,
			navid:navid
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'getpackagesitems';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            setitemDetails(res.data.item_details);
		});
	};

    const releasepackage = () => {
        setShowOverlay(true);
        setOverlayMsg('Processing Release...');
		//get data for warehouse/location dropdown
		const form_data = {
            hqidno: branchIdNo,
			idno: TransactionInformation.activationcode,
            navid: navid,
            packages_info: PackageSalesInformation,
            items_info: TABLE_DATA_ITEMS,
            location_info:TransactionInformation.warehouse
		}
		const formData = new FormData();
		formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'releasesetpackage_co';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("success");
				setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
					setShowMsgBox(false);
                    window.location.reload(false);
				}, 3000)
			}else{
				setShowMsgBox(true);
				setMsg(res.data.result.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
				}, 3000)
			}
		});
	};
	//ApiData Component useState EOF
	const refreshTables = () => {
		TABLE_DATA_ITEMS.length = 0;
        const newData = [...TABLE_DATA_ITEMS];
        loadItemTable([...newData]);
	}

    const prep_table_item = () => {
		let newData = [...TABLE_DATA_ITEMS];
		for (let i=0;i < itemDetails.length;i++) {
			const tempObj = {itemid:itemDetails[i].itemid, itemname:itemDetails[i].itemname, itemqty:Math.abs(itemDetails[i].qty), unit:itemDetails[i].unit}
			addOrUpdate(newData, tempObj);
		}
	}

    const addOrUpdate = (array, item) => {
        const i = array.findIndex(_item => _item.itemid === item.itemid);
        if (i > -1) array[i].itemqty = parseInt(array[i].itemqty) + parseInt(item.itemqty);
        else array.push(item); loadItemTable([...array]);
    }
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//Table Settings
	const [TABLE_DATA, setSelectedPackageTable] = useState([]);
	const [selectedPackage, setSelectedPackage] = useState({});

	const refreshTable = () => {
		const newData = [...TABLE_DATA];
		setSelectedPackageTable([...newData]);
	}

	const TABLE_COLUMNS_ITEMS = [
		{
		  name: 'itemid',
		  label: 'Item ID',
		}, {
		  name: 'itemname',
		  label: 'Item Name',
		}, {
		  name: 'itemqty',
		  label: 'Qty',
		}, {
			name: 'unit',
			label: 'Unit',
		}
	];

    const TABLE_OPTION_ITEMS = {
        selectableRows: false,
	};
	const TABLE_OPTION = {
		filterType: 'checkbox',
		selectableRows: 'single',
		selectableRowsHideCheckboxes: true,
		selectableRowsOnClick: true,
		onRowsDelete: (data) => { updateSelectedPackages(data.data[0].dataIndex) },
	};

	const updateSelectedPackages = (index) => {
		TABLE_DATA.splice(index, 1);
		refreshTable();
	}
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	//Modal Settings EOF

	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
		isLoggedIn();
		setisLoaded(false);
        get_packages_items();
		setisLoaded(true);
    }, []);
    useEffect(() => {
		refreshTables();
		prep_table_item();
    }, [itemDetails]);
    //OnLoad Event/Data Fetching SOF

	//FormData
	const [prep_data, setData] = useState({});
	//FormData EOF
	// const nextpage =  {
	// 	// pathname: "/package-sales-payment",
	// 	pathname: nextPagePath,
	// 	transactionInfo: TransactionInformation, // your data array of objects
	// 	selectedpackagesInfo:TABLE_DATA,
	// 	pageInfo: {
	// 		navid: navid,
	// 		navname: CurrentPage
	// 	}
	// }
	// const nextpageEncoding =  {
	// 	pathname: "/package-sales-packagesitem",
	// 	transactionInfo: TransactionInformation, // your data array of objects
	// 	selectedpackagesInfo:TABLE_DATA,
	// 	pageInfo: {
	// 		navid: navid,
	// 		navname: CurrentPage
	// 	}
	// }
	return (
		!navid ? <Redirect to="/package-sales" /> :
		<div className="page">
            <LoadingOverlay
            active={showOverlay}
            spinner
            text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/package-sales">
						<h4 className="header-title">Package Sales</h4>
					</NavLink>
					<Typography color="textPrimary">{CurrentPage}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
                <form noValidate autoComplete="off">
					<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				    <Grid container spacing={2} alignItems="center" justify="center" className={classes.root}>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
									<h4 className={classes.title}>Transaction Information</h4>
									<h3 className={classes.title}>{TransactionInformation.soldto}</h3>
									<Grid container>
										<Grid item xs={12} sm={6}>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Activation Code:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.activationcode}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Ref Code:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.refcode}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Location:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.warehouse_desc}</FormLabel>
												</Grid>
											</Grid>
										</Grid>
										<Grid item xs={12} sm={6}>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Shipping:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.shipping_desc}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Primary Team:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.primaryteam_desc}</FormLabel>
												</Grid>
											</Grid>
											<Grid container>
												<Grid xs={12} sm={3}>
													<FormLabel>Secondary Team:</FormLabel>
												</Grid>
												<Grid xs={12} sm={9}>
													<FormLabel>{TransactionInformation.secondaryteam_desc}</FormLabel>
												</Grid>
											</Grid>
										</Grid>
									</Grid>
                                </CardContent>
                            </Card>
                        </Grid>
						<Grid item xs={12}>
                            <Card>
                                <CardContent>
									<Grid container spacing={2}>
										<Grid item xs={12}>
                                        {PackageSalesInformation.map((row, ind) => 
                                            <Chip label={PackageSalesInformation[ind]['packagename']} style={{backgroundColor:"green",color:"white",margin:"10px",fontSize:"24px"}}/>
                                        )}
                                            
                                            <MUIDataTable
                                                title={
                                                    <div>
                                                        <div className="table-title">
                                                            Packages Item
                                                        </div>
                                                    </div>
                                                }
                                                id="table-grid"
                                                data={TABLE_DATA_ITEMS}
                                                columns={TABLE_COLUMNS_ITEMS}
                                                options={TABLE_OPTION_ITEMS}
                                            />
                                        </Grid>
									</Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs="12" className={classes.buttonContainer}>
								<Button 
									variant="contained" 
									color="primary"
                                    onClick={releasepackage}
									>
								Release
								</Button>
                        </Grid>
                    </Grid>
                </form>
			</div>
            </LoadingOverlay>
		</div>
	);
};

export default PackageSalesPackagesItems;
